import { RootState, useTypedSelector } from '@fiji/common';
import { selectedOrg } from '@fiji/common/src/features/orgManagement/orgSlice';
import { BackdropLoader } from 'components';
import React, { type JSX } from 'react';
import { useNavigate } from 'react-router-dom';

export const OrgHome = (): JSX.Element => {
    const navigate = useNavigate();
    const currentOrg = useTypedSelector(selectedOrg);
    const currentRealmName = useTypedSelector((state: RootState) => state.common.selectedRealm);

    React.useEffect(() => {
        if (`/${currentRealmName}` === location.pathname && currentOrg?.id) {
            navigate(`/${currentRealmName}/group/${currentOrg?.id}`);
        }
    }, [currentOrg, currentRealmName]);

    return <BackdropLoader isOpen={true} />;
};
